import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import ViewEnquiresHome from "./components/ViewEnquiresHome";

const ViewEnquires = () => {
  return (
    <>
      <Sidebar />
      <MainSection>
        <ViewEnquiresHome />
      </MainSection>
    </>
  );
};

export default ViewEnquires;
